import { NavItem, EventItem } from '@/types';

// Programajánló aloldal ideiglenes kikapcsolása – állítsd true-ra a visszakapcsoláshoz
export const EVENTS_PAGE_ENABLED = false;

/** Public contact address (footer, contact page, privacy policy) */
export const CONTACT_EMAIL = 'hardnewshungary@gmail.com';

export const NAV_ITEMS: NavItem[] = [
  { label: 'FŐOLDAL', to: '/' },
  { label: 'HARDSTYLE', to: '/hardstyle' },
  { label: 'HARD TECHNO', to: '/hard-techno' },
  { label: 'KULTÚRA', to: '/culture' },
  { label: 'PROGRAMAJÁNLÓ', to: '/programajanlo' },
  { label: 'KAPCSOLAT', to: '/kapcsolat' },
];

export const EVENTS_DATA: EventItem[] = [
  {
    id: 'e1',
    enabled: true, // kapcsold false-ra, ha le akarod tiltani ezt az eseményt
    title: 'RAVE YOUR LIFE pres.: JAYRON',
    date: '2026.06.13.',
    time: '22:00 - 05:00',
    location: 'Mundo 2.0., Győr',
    description: 'Holland hard techno zseni debütál Győrben.',
    imageUrl:
      'https://res.cloudinary.com/datxbviji/image/upload/v1780918229/SnapInsta.to_568481219_18198374467319603_7351503421419881051_n_z8fin6.jpg',
    ticketLink: 'https://mundogyor.hu/06-13/',
    price: '4000 Forinttól',
    lineup: ['Jayron', 'Sikztah', 'Jauri', 'SaberZ', 'Selley'],
  },
  {
    id: 'e2',
    enabled: true, // kapcsold false-ra, ha le akarod tiltani ezt az eseményt
    title: 'DUMDUM FESTIVAL',
    date: '2026.06.12-13.',
    time: '22:00-07:00',
    location: 'Arzenál, Budapest',
    description:
      'Az ország egyik legismertebb techno márkája két napon keresztül dübörög az Arzenálban.',
    imageUrl:
      'https://res.cloudinary.com/datxbviji/image/upload/v1780917596/SnapInsta.to_552107497_18023044133685242_4033797832755852011_n_izuuut.jpg',
    ticketLink: 'https://jegyl.ink/DUMDUM-TICKETS',
    price: '10.000 Forinttól',
    lineup: ['Natte Visstick', 'Triptykh', 'In Verruf', 'sokan mások'],
  },
  {
    id: 'e3',
    enabled: true, // kapcsold false-ra, ha le akarod tiltani ezt az eseményt
    title: 'The Etiket x RAVE YOUR LIFE: Nikolina',
    date: '2026. JÚLIUS 24.',
    time: '22:00 - 06:00',
    location: 'Arzenál, Budapest',
    description:
      'A schranz királnyőjét hozza Magyarországra a The Etiket és a RAVE YOUR LIFE csapata.',
    imageUrl:
      'https://res.cloudinary.com/datxbviji/image/upload/v1780917957/SnapInsta.to_681284932_18597436966026688_4239753895592151586_n_la5mb1.jpg',
    ticketLink: 'https://tinyurl.com/nikolina-budapest',
    price: '6490 Forinttól',
    lineup: ['Nikolina', 'Sikztah', 'Svetec', 'Mzperx'],
  },
];

export const AD_BANNER = {
  enabled: true, // ha egyszer le akarod kapcsolni
  label: 'AD',
  title: 'Mentsd le a Spotify listánkat!',
  highlight: 'HARD TECHNO BEST OF',
  ctaLabel: 'Mentsd le!',
  ctaUrl: 'https://open.spotify.com/playlist/6bnaraUoUm2GCn1FajwB5R?si=5f685231fdc5451b', // IDE A SAJÁT LINKED
};

export const POPUP_BANNER = {
  enabled: false, // kapcsold false-ra, ha le akarod tiltani a popup-ot
  title: 'SUB ZERO PROJECT - BLACK EDITION!', // A popup főcíme
  message: 'Január 23-án visszatér Magyarországra a Sub Zero Project!', // A popup üzenete
  buttonText: '71% SOLD OUT, NE MARADJ LE!', // A gomb szövege
  buttonUrl: 'https://cooltix.hu/event/691f05e2b3d483d413791087', // A gomb URL-je (ide írd a saját linked)
  closeButtonText: 'BEZÁRÁS', // A bezáró gomb szövege
};

// Partner logók a kapcsolati oldalon
// Adj hozzá Cloudinary linkeket a logókhoz
export const PARTNER_LOGOS: string[] = [
  'https://res.cloudinary.com/datxbviji/image/upload/v1769961362/outbreak_logo_zqgesn.png',
  'https://res.cloudinary.com/datxbviji/image/upload/v1769961503/blackedition_gstj8g.png',
  'https://res.cloudinary.com/datxbviji/image/upload/v1769961546/rave_black_rnqlzq.png',
];
